import { render, staticRenderFns } from "./PacketTest.vue?vue&type=template&id=5ce922b4"
import script from "./PacketTest.vue?vue&type=script&lang=js"
export * from "./PacketTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports